import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import ProfileCompletion from '../components/ProfileCompletion';
// import { useProfileCompletion } from '../hooks/useProfileCompletion';
import { useAuth } from '../context/AuthContext';
import '../css/CompleteProfilePage.css';

const CompleteProfilePage = () => {
 const navigate = useNavigate();
 const location = useLocation();
 const { user } = useAuth();
 // const { handleProfileComplete } = useProfileCompletion();

 const onProfileComplete = (updatedUser) => {
 // Handle profile completion directly
 console.log('Profile completed:', updatedUser);
 const intendedPath = location.state?.from || '/';
 navigate(intendedPath, { replace: true });
 };

 const handleSkipForNow = () => {
 // Allow user to go back to where they came from
 // This should only be available for certain roles or in development
 const intendedPath = location.state?.from || '/';
 navigate(intendedPath, { replace: true });
 };

 return (
 <div className="complete-profile-page">
 {/* Main Content */}
 <Container className="py-5">
 <Row className="justify-content-center">
 <Col lg={8}>
 {/* Welcome Message */}
 <Card className="welcome-card mb-4 border-0 hover-lift">
 <Card.Body className="text-center py-5">
 <div className="welcome-icon mb-4">
 <i className="fas fa-user-circle" style={{ fontSize: '2rem' }}></i>
 </div>
 <h3 className="welcome-title">Chào mừng đến với hệ thống!</h3>
 <p className="welcome-subtitle">
 Để đảm bảo trải nghiệm tốt nhất và bảo mật thông tin, 
 vui lòng hoàn thành các thông tin cá nhân bắt buộc dưới đây.
 </p>
 </Card.Body>
 </Card>

 {/* Profile Completion Form */}
 <div className="profile-completion-wrapper mb-4">
 <ProfileCompletion onComplete={onProfileComplete} />
 </div>

 {/* Help Section */}
 <Card className="help-section mt-4 border-0 hover-lift">
 <Card.Body className="p-4">
 <h6 className="help-title">
 Tại sao cần hoàn thành thông tin?
 </h6>
 <Row>
 <Col md={6}>
 <div className="help-item mb-3">
 <h6 className="text-success">
 Bảo mật
 </h6>
 <small className="text-muted">
 Thông tin đầy đủ giúp xác thực danh tính và bảo vệ tài khoản của bạn.
 </small>
 </div>
 </Col>
 <Col md={6}>
 <div className="help-item mb-3">
 <h6 className="text-info">
 Thông báo
 </h6>
 <small className="text-muted">
 Hệ thống cần thông tin liên lạc để gửi thông báo quan trọng.
 </small>
 </div>
 </Col>
 <Col md={6}>
 <div className="help-item mb-3">
 <h6 className="text-warning">
 Quản lý
 </h6>
 <small className="text-muted">
 Thông tin phòng ban và công ty giúp phân quyền chính xác.
 </small>
 </div>
 </Col>
 <Col md={6}>
 <div className="help-item mb-3">
 <h6 className="text-primary">
 Báo cáo
 </h6>
 <small className="text-muted">
 Dữ liệu đầy đủ giúp tạo báo cáo và thống kê chính xác.
 </small>
 </div>
 </Col>
 </Row>
 </Card.Body>
 </Card>

 {/* Contact Support */}
 <Card className="contact-support mt-4 border-0 hover-lift">
 <Card.Body className="text-center p-4">
 <h6 className="contact-title">Cần hỗ trợ?</h6>
 <p className="contact-description mb-4">
 Nếu bạn gặp khó khăn trong việc hoàn thành thông tin, 
 vui lòng liên hệ bộ phận hỗ trợ.
 </p>
 <div className="contact-buttons d-flex justify-content-center">
 <a href="tel:0939685880" className="contact-btn btn btn-outline-primary">
 <i className="fas fa-phone me-2"></i>
 Gọi hỗ trợ
 </a>
 <a href="mailto:nhunam1311@gmail.com" className="contact-btn btn btn-outline-primary">
 <i className="fas fa-envelope me-2"></i>
 Gửi email
 </a>
 </div>
 </Card.Body>
 </Card>
 </Col>
 </Row>
 </Container>
 </div>
 );
};

export default CompleteProfilePage;
